module.exports = __webpack_public_path__ + "img/director-speech-bg.111abe4.jpg";